const cartConstants = {
    ADD_TO_CART: "ADD_TO_CART",
    REMOVE_FROM_CART: "REMOVE_FROM_CART",
    CHANGE_QTY: "CHANGE_QTY",
    CHANGE_CHECKOUT_STAGE: "CHANGE_CHECKOUT_STAGE",
    ADD_ADDRESS: "ADD_ADDRESS",
    ORDER_SUCCESSFUL: "ORDER_SUCCESSFUL",
    ADD_MARGIN: "ADD_MARGIN"
};

export default cartConstants;